import { useMutation } from "@tanstack/react-query";
import { initiateGoogleOAuth } from "../../api/bReviewsApi";

export const useInitiateGoogleOAuth = () => {
  return useMutation({
    mutationKey: ["initiate-google-oauth"],
    mutationFn: (data) => initiateGoogleOAuth(data),
    onError: (error) => {
      console.error("Google OAuth initiation error:", error.response || error);
    },
  });
};
